import { useAccount } from 'wagmi'
import { useReadStaking2aContract } from './useReadStaking2aContract'
import { usePepperContractAddress } from '../pepper-contract/usePepperContract'

/*
 * Fetches the user's staked amount
 * @returns The user's staking amount
 */
export function useStaking2aUserStakeAmount() {
	const { address: userAddress } = useAccount()
	const pepperAddress = usePepperContractAddress()

	return useReadStaking2aContract({
		functionName: 'getStake',
		args: [userAddress || '0x', pepperAddress]
	})
}

/*
 * Fetches the user's stake data considering the user's lock status
 * @returns The user's userTotalLocked and userTotalStaked considering the user's lock status
 * @dev This is used to return the actual staked, unstaked, ... amounts, but the values
 * for claimable amount
 */

export function useStaking2aUserStakeData() {
	const { address: userAddress } = useAccount()
	const pepperAddress = usePepperContractAddress()

	return useReadStaking2aContract({
		functionName: 'getStakeDataLatest',
		args: [userAddress || '0x', pepperAddress, false]
	})
}

/*
 * Fetches the user's stake data without considering the user's lock status
 * @returns The user's userTotalLocked and userTotalStaked without considering the user's lock status
 * @dev This is used to return the actual claimable amount, as getStakeDataLatest is not
 * returning the expected values
 */

export function useStaking2aUserStakeDataWithoutLockStatus() {
	const { address: userAddress } = useAccount()
	const pepperAddress = usePepperContractAddress()

	return useReadStaking2aContract({
		functionName: 'getStakeData',
		args: [userAddress || '0x', pepperAddress, false]
	})
}
